import React from 'react';
import { Link } from 'react-router-dom';

const NavBarLogo = () => (
  <div className="text-2xl sm:text-3xl md:text-4xl font-bold"> {/* Adjust font size for small screens */}
    <Link to="/explore" className="text-white hover:text-gray-300">
      BookurSpot
    </Link>
  </div>
);

export default NavBarLogo;
